<div class="page-body-wrapper">
    <div class="row">
        <div class="col-lg-12">
            <div>
                <button mat-raised-button color="primary" (click)="openCreateModal()">
                    <mat-icon class="mdc-button__icon">add</mat-icon>
                    <span class="mdc-button__label">Yeni Çalışan Ekle</span>
                </button>
            </div>
            <div class="table-responsive table-hidden-scroll" style="overflow-x:hidden">
                <div class="row filter-wrapper">
                    <div class="col-lg-3">
                        <mat-form-field class="absence-form-field">
                            <mat-label>Ad</mat-label>
                            <input matInput placeholder="Ex. Pizza" [(ngModel)]="filterName">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                        <mat-form-field class="absence-form-field">
                            <mat-label>Soyad</mat-label>
                            <input matInput placeholder="Ex. Pizza" [(ngModel)]="filterSurname">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                        <mat-form-field class="absence-form-field">
                            <mat-label>Ünvan Seçiniz</mat-label>
                            <mat-select [(value)]="selectedTitle">
                                <mat-option *ngFor="let jobTitle of employeeTitleList" [value]="jobTitle">
                                    {{jobTitle.description}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                        <mat-form-field class="absence-form-field">
                            <mat-label>Departman Seçiniz</mat-label>
                            <mat-select [(value)]="selectedDepartment">
                                <mat-option *ngFor="let department of departmentList" [value]="department">
                                    {{department.lookupValue ? (department.lookupValue + ' - ' + department.description) : department.description}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <!--<div class="col-lg-6">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Arama</mat-label>
                            <input matInput (keyup)="applyFilter($event)" placeholder="">
                        </mat-form-field>
                    </div>-->
                </div>
                <div class="row filter-wrapper">
                    <div class="col-lg-2">
                        <mat-form-field class="absence-form-field">
                            <mat-label>Cinsiyet Seçiniz</mat-label>
                            <mat-select [(value)]="selectedGender">
                                <mat-option *ngFor="let gender of genderList" [value]="gender">
                                    {{gender.description}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-2" >
                        <mat-form-field class="absence-form-field">
                            <mat-label>Doğum Tarihi Başlangıç</mat-label>
                            <input readonly matInput [matDatepicker]="pickerStart1"
                                [formControl]="startDateFilterValue1" style="max-width: 160px;">
                            <mat-datepicker-toggle matSuffix [for]="pickerStart1"></mat-datepicker-toggle>
                            <mat-datepicker startView="multi-year" #pickerStart1></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-2" >
                        <mat-form-field class="absence-form-field">
                            <mat-label>Doğum Tarihi Bitiş</mat-label>
                            <input readonly matInput [matDatepicker]="pickerEnd1" [formControl]="endDateFilterValue1">
                            <mat-datepicker-toggle matSuffix [for]="pickerEnd1"></mat-datepicker-toggle>
                            <mat-datepicker #pickerEnd1 startView="multi-year"></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-2" >
                        <section class="absence-form-field" style="display: flex; gap: 5px;">
                            <mat-checkbox [(ngModel)]="activeFilterValue">Aktif</mat-checkbox>
                            <mat-checkbox [(ngModel)]="isNewFilterValue">Yeni Aktarılan</mat-checkbox>
                        </section>
                    </div>
                    <div class="col-lg-4 table-header-button-wrapper">
                        <button mat-raised-button color="warn" (click)="filterGrid()"
                            style="margin-right: 5px;margin-top: 5px;">Filtrele</button>
                        <button mat-raised-button color="link" (click)="clearfilterGrid()"
                            style="margin-right: 5px;margin-top: 5px;">Temizle</button>
                        <button mat-raised-button class="button-small" style="background-color: #28a745; color: white;margin-top: 5px;"
                            matTooltip="Excele aktar" (click)="exportArray()">
                            Excel'e Aktar
                        </button>
                    </div>
                </div>

                <table mat-table matTableExporter class="lessons-table mat-elevation-z8" [hiddenColumns]="[0,6]"
                    #exporter="matTableExporter" multiTemplateDataRows #employeeListTable matSort
                    [dataSource]="dataSource" (matSortChange)="employeeSortEvent($event)" style="width: 100%">

                    <ng-container matColumnDef="profilePhoto">
                        <th mat-header-cell *matHeaderCellDef style="flex-grow: 0.5 !important;"></th>
                        <td mat-cell *matCellDef="let element" style="flex-grow: 0.5 !important;">
                            <img class="list-profile-photo" alt=" " *ngIf="element.profilePhoto"
                                src="{{fileUploadRoot}}/{{element.profilePhoto.filePath}}">
                            <i class="material-icons icon" *ngIf="element.profilePhoto == null"
                                style="font-size: 36px;color: #707173">
                                account_circle
                            </i>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Adı Soyadı </th>
                        <td mat-cell *matCellDef="let element">{{element.name}} {{element.surname}}</td>
                    </ng-container>
                    <ng-container matColumnDef="tel">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Telefon </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.tel | phone }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                        <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                    </ng-container>
                    <ng-container matColumnDef="departmentname">
                        <th mat-header-cell *matHeaderCellDef> Departman </th>
                        <td mat-cell *matCellDef="let element">{{element.department ? element.department.description :
                            null}} </td>
                    </ng-container>
                    <ng-container matColumnDef="jobTitlename">
                        <th mat-header-cell *matHeaderCellDef> Ünvan </th>
                        <td mat-cell *matCellDef="let element">{{element.jobTitle ? element.jobTitle.description :
                            null}} </td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element;" class="actions-mat-cell">
                            <button mat-icon-button matTooltip="Düzenle"
                                class="employee-iconbutton iconbutton action-edit-button"
                                (click)="openUpdateModal($event,element)">
                                <mat-icon class="employee-action-icon" aria-label="Edit">edit</mat-icon>
                            </button>
                            <button mat-icon-button matTooltip="Sil"
                                class="employee-iconbutton iconbutton action-delete-button"
                                (click)="openDeleteModal($event,element)">
                                <mat-icon class="employee-action-icon" aria-label="delete">delete_forever</mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="expandedDetail">
                        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                            <div class="example-element-detail"
                                *ngIf="element.absenceDeservedList.data != null && element.absenceDeservedList.data.length > 0"
                                [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                                <div class="inner-table mat-elevation-z8" *ngIf="expandedElement">
                                    <table mat-table #innerTables #innerSort="matSort"
                                        [dataSource]="element.absenceDeservedList" matSort>


                                        <ng-container matColumnDef="absenceTypeDesc">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> İzin Türü </th>
                                            <td mat-cell *matCellDef="let element"> {{element.absenceTypeDesc}} </td>
                                        </ng-container>
                                        <ng-container matColumnDef="startDate">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Hakediş Tarihi </th>
                                            <td mat-cell *matCellDef="let element">
                                                {{element.startDate.substring(0,10)}} </td>
                                        </ng-container>
                                        <ng-container matColumnDef="deservedAmount">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Hakediş </th>
                                            <td mat-cell *matCellDef="let element"> {{element.deservedAmount}}
                                                {{element.unitOfInterval}} </td>
                                        </ng-container>
                                        <ng-container matColumnDef="transferAmount">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Devreden </th>
                                            <td mat-cell *matCellDef="let element"> {{element.transferAmount}}
                                                {{element.unitOfInterval}} </td>
                                        </ng-container>
                                        <ng-container matColumnDef="totalUsedAbsenceAmount">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Kullanılan </th>
                                            <td mat-cell *matCellDef="let element"> {{element.totalUsedAbsenceAmount}}
                                                {{element.unitOfInterval}} </td>
                                        </ng-container>
                                        <ng-container matColumnDef="remainingAmount">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Kalan </th>
                                            <td mat-cell *matCellDef="let element"> {{element.remainingAmount}}
                                                {{element.unitOfInterval}} </td>
                                        </ng-container>


                                        <tr mat-header-row *matHeaderRowDef="innerDisplayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: innerDisplayedColumns;"></tr>
                                    </table>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                        [class.example-element-row]="row.absenceDeservedList.data != null && row.absenceDeservedList.data.length > 0"
                        [class.example-expanded-row]="expandedElement === row" (click)="toggleRow(row)"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                </table>

                <mat-paginator (page)="employeeListEvent($event)" #employeePaginator="matPaginator"
                    [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>
</div>